import React from "react";

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';

import Logo from "../assets/img/logo.svg";

const SiteNav = () => {
    return (
        <header id="header" className="site-header">
            <div className=" header-first navbar site-navbar">
                <div className="navbar-header">
                    <Container>
                        <button aria-controls="basic-navbar-nav" type="button" aria-label="Toggle navigation" className="navbar-toggler collapsed">
                            <span className="navbar-toggler-icon">
                                <i className="bi bi-gear"></i>
                            </span>                            
                        </button>
                        <a href="#"><img src={Logo} alt="madadoo shop logo" width="160" /></a>
                    </Container>
                </div>
            </div>
            <div className="header-second flex justify-content-center align-item-center">
                <Container>
                    <div id="navSearch">
                        <input type="text" name="term" placeholder="Rechercher..." />
                    </div>
                </Container>
            </div>
        </header>
    );

}
export default SiteNav;